<ng-container *ngIf="fundVideoList">
  <div>
    <div class="background-container">
      <div class="container main-container">
        <div class="col-lg-5">
          <h3 class="vg-heading-three margin-bottom-1rem">
            {{fundVideoList[youtubeId]?.title}}
          </h3>
          <span class="vg-paragraph-one margin-bottom-1rem">
            {{fundVideoList[youtubeId]?.description}}
          </span>
        </div>
        <div class="video-container col-lg-6">

          <c11n-web-b5-youtube-player #videoContainer  [ngClass]="{
                      'video-hide': !checkCookie
                    }"
          
            *ngIf="youtubeId === 'cMP2BzZ8yIo'"
             video="cMP2BzZ8yIo"
             title="Investing in the future of health care"
          >
            <img
              alt="Portrait of Jean Hynes"
              src="https://corporate.vanguard.com/content/dam/corp/articles/images/jean_hynes_video_still.jpg"
            />
            <button
              aria-label="Play button for video: 'Investing in the future of health care'"
            >
              <c11n-web-b5-icon name="play"></c11n-web-b5-icon>
            </button>
          </c11n-web-b5-youtube-player>

          <c11n-web-b5-youtube-player #videoContainer [ngClass]="{
                      'video-hide': !checkCookie
                    }" *ngIf="youtubeId === 'IKz6h56DU7I'" video="IKz6h56DU7I" title="Wellington Management Company">
            <img alt="Portrait of Jean Hynes"
              src="https://corporate.vanguard.com/content/dam/corp/articles/images/jean_hynes_video_still.jpg" />
            <button aria-label="Play button for video: 'Wellington Management Company'">
              <c11n-web-b5-icon name="play"></c11n-web-b5-icon>
            </button>
          </c11n-web-b5-youtube-player>

          
            <div class="video-opt-in" [ngClass]="{
              'video-hide': checkCookie
            }">
    <div>
      <img class="video-opt-in-image"
        src="https://corporate.vanguard.com/content/dam/corp/articles/images/jean_hynes_video_still.jpg" [alt]="alt">
      <h2 class="video-opt-in-text">You have certain cookies disabled on the Vanguard site.<br> In order to
        watch this video, you must agree to the use of cookies provided by YouTube. <br> Click <button
          (click)="addInPlayVideo()"
          style="border: none; font-weight:bold;  background: none; padding: 0; color: white; cursor: pointer;"
          class="hover-underline text-underline">here</button> to permit these cookies and watch the video.</h2>
    </div>
  </div>


          <div class="video-information">
            <a role="button" tabindex="0" href="javascript:void(0)" class="vg-paragraph-one dialog-button" style="color:#145BFF; border-bottom: 2px dotted #145BFF; font-weight: bold; margin-right: 40px;" (click)="setDialogInfo(fundVideoList[youtubeId]?.title); constellationVideoModal.openModalDialog($event);">View transcript</a>
            <span class="vg-paragraph-one">Video length: {{fundVideoList[youtubeId]?.duration}}</span>
          </div>
        </div>
      </div>
    </div>

    <c11n-modal-dialog
      modalId="constelationVideoModal"
      [headingText]="dialogTitle"
      #constellationVideoModal
    >
      <div c11n-modal-dialog-body>
        <ng-container *ngTemplateOutlet="simpleDialogContent"></ng-container>
      </div>
    </c11n-modal-dialog>
  </div>
  <ng-template #simpleDialogContent>
    <div>
      <p class="vg-paragraph-one"  [innerHTML]="fundVideoList[youtubeId]?.transcriptBody">
      </p>
    </div>

  </ng-template>

</ng-container>
